//
// 3rd-Party Plugins JavaScript Includes
//


//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
////  Mandatory Plugins Includes(do not remove or change order!)  ////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////

// Jquery - jQuery is a popular and feature-rich JavaScript library. Learn more: https://jquery.com/
window.jQuery = window.$ = require('jquery');
require('../../core/js/vendors/plugins/jquery.init');

// Bootstrap - The most popular framework uses as the foundation. Learn more: http://getbootstrap.com
window.bootstrap = require('bootstrap');

// Popper.js - Tooltip & Popover Positioning Engine used by Bootstrap. Learn more: https://popper.js.org
window.Popper = require('@popperjs/core');

// Wnumb - Number & Money formatting. Learn more: https://refreshless.com/wnumb/
window.wNumb = require('wnumb');

// Moment - Parse, validate, manipulate, and display dates and times in JavaScript. Learn more: https://momentjs.com/
window.moment = require('moment');

// ES6-Shim - ECMAScript 6 compatibility shims for legacy JS engines.  Learn more: https://github.com/paulmillr/es6-shim
require('es6-shim/es6-shim.min.js');


//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
///  Optional Plugins Includes(you can remove or add)  ///////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////






// Date Range Picker - A JavaScript component for choosing date ranges, dates and times: https://www.daterangepicker.com/
require('bootstrap-daterangepicker/daterangepicker.js');

// Bootstrap Maxlength - This plugin integrates by default with Twitter bootstrap using badges to display the maximum length of the field where the user is inserting text: https://github.com/mimo84/bootstrap-maxlength
// require('bootstrap-maxlength/src/bootstrap-maxlength.js');
// require('../../core/plugins/bootstrap-multiselectsplitter/bootstrap-multiselectsplitter.min.js');

// Select2 - Select2 is a jQuery based replacement for select boxes: https://select2.org/
require('select2');
require('../../core/js/vendors/plugins/select2.init.js');

// Inputmask - is a javascript library which creates an input mask: https://github.com/RobinHerbots/Inputmask
// require('inputmask/dist/inputmask.js');
// require('inputmask/dist/bindings/inputmask.binding.js');

// noUiSlider - is a lightweight range slider with multi-touch support and a ton of features. It supports non-linear ranges, requires no external dependencies: https://refreshless.com/nouislider/
// window.noUiSlider = require('nouislider/dist/nouislider.min.js');

// The autosize - function accepts a single textarea element, or an array or array-like object (such as a NodeList or jQuery collection) of textarea elements: https://www.jacklmoore.com/autosize/
// window.autosize = require('autosize/dist/autosize.min.js');

// DropzoneJS -  is an open source library that provides drag'n'drop file uploads with image previews: https://www.dropzonejs.com/
window.Dropzone = require('dropzone/dist/min/dropzone.min.js').default;
require('../../core/js/vendors/plugins/dropzone.init.js');

// Tagify - Transforms an input field or a textarea into a Tags component, in an easy, customizable way, with great performance and small code footprint, exploded with features: https://github.com/yairEO/tagify
require('@yaireo/tagify/dist/tagify.polyfills.min.js');
window.Tagify = require('@yaireo/tagify/dist/tagify.min.js');
window.DragSort = require('@yaireo/dragsort');

// Toastr - is a Javascript library for non-blocking notifications. jQuery is required. The goal is to create a simple core library that can be customized and extended: https://github.com/CodeSeven/toastr
window.toastr = require('toastr/build/toastr.min.js');

// Sweetalert2 - a beautiful, responsive, customizable and accessible (WAI-ARIA) replacement for JavaScript's popup boxes: https://sweetalert2.github.io/
window.Swal = window.swal = require('sweetalert2/dist/sweetalert2.min.js');
require('../../core/js/vendors/plugins/sweetalert2.init.js');

// A lightweight script to animate scrolling to anchor links
window.SmoothScroll = require('smooth-scroll/dist/smooth-scroll.js');

require('flatpickr/dist/flatpickr.js');

// Bootstrap Timepicker - Easily select a time for a text input using your mouse or keyboards arrow keys: https://jdewit.github.io/bootstrap-timepicker/
require('bootstrap-timepicker/js/bootstrap-timepicker.js');

require('ion-rangeslider/js/ion.rangeSlider.js');
require( 'jquery-maskmoney');
// require( 'jquery-formatcurrency');
require( 'jquery-mask-plugin');
require('../../custom/plugins/jquery-sked-tape/jquery.skedTape');

//plugins
// require( 'web-animations-js');

// require( '../../custom/plugins/pickr/pickr.min.js');
require( 'jquery-minicolors/jquery.minicolors');
require( 'jquery-nestable');
require( 'jquery-validation');
// require( 'ajax-bootstrap-select');
// require( 'jquery-ui/ui/widgets/autocomplete.js');
require( 'jquery-ui-slider/jquery-ui');

require( 'jquery-ui/ui/widgets/draggable');
require( 'jquery-ui/ui/widgets/sortable');
require( 'jquery-ui/ui/widgets/resizable');
require( 'bootstrap-notify');

require( './jquery-collision.min');

// used at: categories, ...
require( 'jquery.fancytree');
require( '../../custom/plugins/ComboTree/comboTreePlugin.js');

window.FormValidation = require('./formvalidation/dist/js/FormValidation.min.js');
window.FormValidation.plugins.Bootstrap5 = require('./formvalidation/dist/js/plugins/Bootstrap5.js');

require( '../../custom/plugins/colorPick/src/colorPick.min');
require( '../../custom/plugins/fontselect/jquery.fontselect');

// window.EditorJS = require('@editorjs/editorjs');

import { GridStack } from 'gridstack';
window.GridStack = GridStack;
window.Pusher = require('pusher-js');
